// Copyright (c) StrangeBee 2024

import { Routes as AccountRoutes } from '@Pages/Account';
import { Routes as AdminRoutes } from '@Pages/Admin';
import { Routes as AlertsRoutes } from '@Pages/Alerts';
import { Routes as CasesRoutes } from '@Pages/Cases';
import { Routes as DashboardRoutes } from '@Pages/Dashboard';
import { Routes as SearchRoutes } from '@Pages/Search';
import { Routes as GlobalTasksRoutes } from '@Pages/GlobalTasks';

export default {
    AccountRoutes,

    CasesRoutes,
    AlertsRoutes,
    GlobalTasksRoutes,

    DashboardRoutes,
    SearchRoutes,

    AdminRoutes,
};
